'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$() {
  this.aLP = null;
  this.aLQ = false;
  this.aLR = null;
  this.aLS = false;
  this.aLJ = null;
  this.aLK = false;
  this.aLL = null;
  this.aLM = false;
  this.aLN = null;
  this.aLO = false;
  this.aLT = null;
  this.aLU = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$.prototype = $p;
$p.aA = (function() {
  if ((!this.aLQ)) {
    this.aLP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate$Newtype$$anon$2(this);
    this.aLQ = true;
  }
  return this.aLP;
});
$p.t1 = (function() {
  if ((!this.aLS)) {
    this.aLR = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate$Newtype$$anon$4(this);
    this.aLS = true;
  }
  return this.aLR;
});
$p.bW = (function() {
  if ((!this.aLK)) {
    this.aLJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aLK = true;
  }
  return this.aLJ;
});
$p.asg = (function() {
  if ((!this.aLM)) {
    this.aLL = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lalleycats_Empty$$anon$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => {
      var e$proxy1 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$().iu(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_data_FrameworkDate$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_FrameworkPlatform$().ag0())));
      matchResult9: {
        var $x_1;
        if ((e$proxy1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
          throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), (("Expected Right, got Left(" + e$proxy1.bj) + ")"));
        }
        if ((e$proxy1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
          var ev$1 = e$proxy1.aI;
          var $x_1 = ((ev$1 === null) ? null : ev$1.cs);
          break matchResult9;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(e$proxy1);
      }
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate($x_1);
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lalleycats_Empty$());
    this.aLM = true;
  }
  return this.aLL;
});
$p.a5n = (function() {
  if ((!this.aLO)) {
    this.aLN = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Invoice Date";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aLO = true;
  }
  return this.aLN;
});
$p.bss = (function() {
  if ((!this.aLU)) {
    this.aLT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().Cc;
    this.aLU = true;
  }
  return this.aLT;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$, "app.data.data_point_types$package$InvoiceDate$", ({
  FX: 1,
  B: 1,
  C: 1,
  f0: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceDate$ };
//# sourceMappingURL=app.data.data_point_types$package$-Invoice-Date$.js.map
